import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { userSelector } from "../../slices/userSlice";
import { interpreterProfileSelector } from "../../slices/interpreter/profileSlice";
import { UserName } from "components/common/UserName";
import { Nav } from "reactstrap";
import { cdn } from '../../constants/common';
function Sidebar(props) {
  const location = useLocation();
  const sidebar = React.useRef();
  const activeRoute = (routeName) => {
    const pathSegments = location.pathname.split('/').filter(segment => segment);
    return "/" + pathSegments[pathSegments.length - 1] === routeName ? 'active' : "";
  };
  const mainRoutes = props.routes;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const { user } = useSelector(userSelector);
  const { interpreterProfile } = useSelector(interpreterProfileSelector);
  
  const displayUser = interpreterProfile?.user || user?.user;
  const [userSlice, setUserSlice] = useState(null);

  const handleNavLinkClick = () => {
    if (window.innerWidth <= 991) {
      props.toggleSidebar();
    }
  };

  useEffect(() => {
    const loadUserSlice = async () => {
      const module = await import("../../slices/userSlice");
      setUserSlice(module);
    };
    loadUserSlice();
  }, []);

  const handleLogout = () => {
    navigate('/login', { replace: true });
    if (userSlice) {
      dispatch(userSlice.logout());
    }
  };

  console.log(interpreterProfile , 'displayUserdisplayUser')
  
  return (
    <>
      <div
        className={`sidebar ${props.isSidebarOpen ? "toggled" : ""}`}
        data-color={props.bgColor}
        data-active-color={props.activeColor}
      >
        <div className="logo">
          <button className="close_side" onClick={props.toggleSidebar}>✕</button>
          <Link to="/" className="simple-text logo-mini">
            <div className="logo-img">
              <img src="/images/logo-nav.png" alt="react-logo" />
              <img src="/images/logo-fill.png" alt="react-logo" />
            </div>
          </Link>
        </div>
        <div className="side_user_row">
          <div className="side_user_image">
            {displayUser?.image ? (
              <img src={cdn + displayUser.image} alt={displayUser.name} />
            ) : (
              <img src="/images/default-person.png" alt="Default profile" />
            )}
          </div>
          <div className="side_user_title">
            <span>Welcome,</span>
            <UserName name={displayUser?.name} lastName={displayUser?.last_name} />
          </div>
        </div>
        <div className="sidebar-wrapper" ref={sidebar}>
          <Nav>
            {/* Main Section */}
            <li><p className="nav_head">General</p></li>

            {mainRoutes.map((prop, key) => {
              return (
                !prop?.subRoute && <li
                  className={
                    activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
                  }
                  key={key}
                >
                  <NavLink to={prop.layout + prop.path} className="nav-NavLink" onClick={handleNavLinkClick}>
                    <div className="line_wrap">
                      <img src={prop.icon} alt="side" />
                      <img src={prop.iconActive} alt="side" />
                      <h2>{prop.title}</h2>
                    </div>
                  </NavLink>
                </li>
              );
            })}

            <li>
              <a href="#" onClick={(e) => {e.preventDefault(); handleLogout();}} className="nav-NavLink p-0">
                <div className="line_wrap wrap_logout">
                  <img src='/images/LogOut.png' alt="side" />
                  <img src='/images/LogOut-fill.png' alt="side" />
                  <h2>Log Out</h2>
                </div>
              </a>
            </li>
          </Nav>
        </div>
      </div>
    </>
  );
}

export default Sidebar;